import { loadingLottie } from "assets/lottie";
import { gray2, gray3, gray6, gray8, white } from "assets/styleUtils";
import SvgCheckLine from "assets/svgIcons/SvgcheckLine";
import { EmptyView, Icon } from "components";
import {
  getCompanyList,
  ICategoryType,
  ICompany,
  TCompanySort,
} from "data/company";
import useInfiniteScroll from "hooks/useInfiniteScroll";
import useInitData from "hooks/useInitData";
import useModal from "hooks/useModal";
import useUser from "hooks/useUser";
import Lottie from "lottie-react";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useRoutes } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  companyCategoryState,
  companyEventListState,
  companyLocationFilterState,
  companyWeddingFilterState,
} from "recoil/company";
import CompanyItem from "./CompanyItem";
import styles from "./style.module.css";

interface ISorting {
  text: string;
  value: TCompanySort;
}
const sortingList: ISorting[] = [
  { text: "가나다순", value: "abc" },
  { text: "인기순", value: "popular" },
  { text: "최신순", value: "recent" },
];

export default function CompanyPage() {
  const [isInit, setIsInit] = useState(true);
  const { params } = useParams();
  const [category, setCategory] = useState<ICategoryType>("웨딩홀");
  const [list, setList] = useState<{
    Contructor: ICompany[];
    page: IPage;
  } | null>(null);
  const [sorting, setSorting] = useState<ISorting>(sortingList[0]);
  const listRef = useRef<HTMLDivElement | null>(null);
  const { visibleModal, removeModal } = useModal();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const listData = list?.Contructor || [];
  const companyLocation = useRecoilValue(companyLocationFilterState);
  const weddingFilter = useRecoilValue(companyWeddingFilterState);
  const companyEventList = useRecoilValue(companyEventListState);
  const [showFilter, setShowFilter] = useState(false);
  const [selectWeddingFilter, setSelectWeddingFilter] = useState<number[]>([]);
  const [selectWeddingLocaionFilter, setSelectWeddingLocaionFilter] = useState<
    {
      location_1: string;
      location_2?: string;
      selected: boolean;
    }[]
  >([]);
  const { user } = useUser();
  const { getCategory, getCompanyFilterData } = useInitData();

  async function getData(_page: number) {
    try {
      if (_page === 1) {
        setIsInit(true);
      }
      const filters = {
        category,
        sorting: sorting.value,
        page: String(_page),
        filter_list: category === "웨딩홀" ? selectWeddingFilter : [],
        location_1:
          category === "웨딩홀"
            ? selectWeddingLocaionFilter
                .filter((item) => item.selected)
                .map((item) => item.location_1)
            : [],
        location_2:
          category === "웨딩홀"
            ? selectWeddingLocaionFilter
                .filter((item) => item.selected)
                .map((item) => item.location_2)
                .filter((item): item is string => item !== undefined)
            : [],
      };

      const { data } = await getCompanyList(filters);
      const { Contructor, page } = data.result || {};
      if (data && Contructor && page) {
        setTotalPages(page.maxpage);
        setList((prevList) => {
          if (_page === 1) {
            return data.result;
          } else {
            return {
              ...prevList,
              Contructor: [...(prevList?.Contructor || []), ...Contructor],
              page: page,
            };
          }
        });
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setTimeout(() => setIsInit(false), 500);
    }
  }

  function openSorting() {
    visibleModal({
      id: "CATEGORY_MODAL",
      edge: "bottom",
      // isSlide: true,
      modalchildren: (
        <div>
          {sortingList.map((_sorting, index) => {
            const isActive = sorting.value === _sorting.value;
            return (
              <div
                onClick={() => {
                  removeModal("CATEGORY_MODAL");
                  setSorting(_sorting);
                }}
                key={index}
                style={{
                  width: "100%",
                  height: "60px",
                  padding: "0 24px",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  ...(isActive && { backgroundColor: gray8 }),
                }}
              >
                <div>{_sorting.text}</div>
                <div>{isActive && <SvgCheckLine color={gray2} />}</div>
              </div>
            );
          })}
        </div>
      ),
    });
  }
  useEffect(() => {
    getCategory();
    getCompanyFilterData();
  }, []);

  useEffect(() => {
    getData(page);
  }, [
    page,
    category,
    sorting,
    selectWeddingFilter,
    selectWeddingLocaionFilter,
  ]);

  useEffect(() => {
    setPage(1);
  }, [selectWeddingLocaionFilter, selectWeddingFilter, sorting]);

  useEffect(() => {
    if (companyLocation) {
      const locations = companyLocation.reduce((acc, cur) => {
        const subList =
          cur.location_2.length > 0
            ? cur.location_2.map((sub) => ({
                location_1: cur.location_1,
                location_2: sub,
                selected: false,
              }))
            : [{ location_1: cur.location_1, selected: false }];
        return acc.concat(subList);
      }, [] as { location_1: string; location_2?: string; selected: boolean }[]);

      setSelectWeddingLocaionFilter(locations);
    }
  }, [companyLocation]);

  // useEffect(() => {
  //   if (params?.category) {
  //     setCategory(params.category);
  //   }
  // }, [params]);
  useInfiniteScroll({ page, setPage, getData, ref: listRef, totalPages });
  return (
    <div>
      <div>
        {/* TODO: 추후 작업 */}
        {/* <div
            style={{
              display: "flex",
              overflowX: "auto",
              width: "100%",
              whiteSpace: "nowrap",
              color: "14px",
              scrollbarWidth: "thin",
              cursor: "pointer",
            }}
          >
            {categoryList.map((item, index) => {
              return <div style={{ padding: "12px 6px" }}>{item.category}</div>;
            })}
          </div> */}
        <div style={{ padding: "14px 16px 0px 16px" }}>
          {companyEventList.map((event, index) => {
            return (
              <a
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "12px 0",
                  cursor: "pointer",
                }}
                href={event.link}
                key={index}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={event.icon}
                    style={{ width: "40px", height: "40px" }}
                  ></img>
                  <div
                    style={{
                      marginLeft: "16px",
                      lineHeight: "150%",
                    }}
                  >
                    <div>{event.sub_title}</div>
                    <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                      {event.title}
                    </div>
                  </div>
                </div>
                <Icon name="arrowRight" color="#AEB1B6" />
              </a>
            );
          })}
          <div style={{ margin: "5.5px 0" }}>
            <div className={styles.subfilterContainer}>
              <div className={styles.subfilterTitle}>지역</div>
              <div
                className={styles.overflowbar}
                style={{
                  display: "flex",
                  overflowX: "scroll",
                  whiteSpace: "nowrap",
                }}
              >
                {selectWeddingLocaionFilter.map((item, index) => {
                  const isActive = item.selected;
                  const activeStyles = isActive
                    ? { backgroundColor: "#F8FCFC", color: "#79C5BC" }
                    : {};
                  return (
                    <div
                      key={index}
                      className={`${styles.subFilterItem} ${
                        isActive ? styles.subfilterActive : ""
                      }`}
                      style={{
                        padding: "5.5px 12px",
                        cursor: "pointer",
                        ...activeStyles,
                      }}
                      onClick={() =>
                        setSelectWeddingLocaionFilter([
                          ...selectWeddingLocaionFilter.map((temp) => {
                            if (
                              temp.location_1 === item.location_1 &&
                              temp.location_2 === item.location_2
                            ) {
                              return {
                                ...temp,
                                selected: !item.selected,
                              };
                            }
                            return temp;
                          }),
                        ])
                      }
                    >
                      {item.location_1}
                      {!!item.location_2 && ` ${item.location_2}`}
                    </div>
                  );
                })}
              </div>
            </div>

            {Object.keys(weddingFilter).map((key, index) => {
              const filter = weddingFilter[key];

              if (!showFilter && index > 0) {
                return;
              }
              return (
                <div key={index} className={`${styles.subfilterContainer}`}>
                  <div className={styles.subfilterTitle}>{filter.title}</div>
                  <div
                    className={styles.overflowbar}
                    style={{
                      display: "flex",
                      overflowX: "scroll",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {filter.list.map((item, index) => {
                      const isActive =
                        selectWeddingFilter.filter(
                          (temp) => Number(temp) === item.no,
                        ).length > 0;
                      const activeStyles = isActive
                        ? { backgroundColor: "#F8FCFC", color: "#79C5BC" }
                        : {};
                      return (
                        <div
                          key={index}
                          className={`${styles.subFilterItem} ${
                            isActive ? styles.subfilterActive : ""
                          }`}
                          style={{
                            padding: "5.5px 12px",
                            cursor: "pointer",
                            ...activeStyles,
                          }}
                          onClick={() =>
                            isActive
                              ? setSelectWeddingFilter([
                                  ...selectWeddingFilter.filter(
                                    (temp) => Number(temp) !== item.no,
                                  ),
                                ])
                              : setSelectWeddingFilter([
                                  ...new Set([...selectWeddingFilter, item.no]),
                                ])
                          }
                        >
                          {item.content.includes("X" || "x" || "없음")
                            ? ""
                            : item.content}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          <div onClick={() => setShowFilter(!showFilter)}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTop: `1px solid ${gray6}`,
                borderRadius: "5px",
                padding: "14px 0",
                cursor: "pointer",
              }}
            >
              {!showFilter ? (
                <>
                  <div style={{ marginRight: "12px" }}>
                    더 많은 필터 펼쳐보기
                  </div>
                  <Icon name="arrowBottom" color="#AEB1B6" width={16} />
                </>
              ) : (
                <>
                  <div style={{ marginRight: "12px" }}>필터 접기</div>
                  <Icon name="arrowUp" color="#AEB1B6" width={16} />
                </>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "0 14px 8px 14px",
          }}
        >
          <div onClick={openSorting} className={styles.filter}>
            <div style={{ fontSize: "12px" }}>{sorting.text}</div>
            <img
              src="/images/down.png"
              style={{ height: "16px", width: "16px", marginLeft: "2px" }}
            />
          </div>
        </div>
        <>
          {isInit ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 50px",
              }}
            >
              <Lottie animationData={loadingLottie} loop={true} />
            </div>
          ) : !!listData && listData.length !== 0 ? (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(38%, 1fr))",
                  padding: "0 10px",
                }}
              >
                {listData.map((_list, index) => {
                  return (
                    <div>
                      <div key={index}>
                        <CompanyItem {..._list} />
                      </div>
                    </div>
                  );
                })}
              </div>
              {!!list && list.page.cur < list?.page.maxpage && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "0px",
                    padding: "50px 120px",
                  }}
                >
                  <Lottie
                    animationData={loadingLottie}
                    loop={true}
                    width="120px"
                  />
                </div>
              )}
            </>
          ) : (
            <div style={{ height: "50vh" }}>
              <EmptyView content={`${category} 업체가 존재하지 않습니다.`} />
            </div>
          )}
        </>
      </div>
      {listData.length > 8 && <div ref={listRef} />}
    </div>
  );
}
